import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { t } from 'i18next';

import { DocumentType, DocumentTypeWithVirtual } from 'support/types';
import { PropertyFilterType } from 'support/types/filters';

export const buildDocumentTypeFilter = (key: string, exclude?: Array<DocumentType>) => ({
  key,
  type: PropertyFilterType.dropdown,
  label: t('transactions:list.filter.messageTypes.label'),
  Icon: DocumentTextIcon,
  value: '',
  dropDownOptions: {
    dropdownValues: [
      { label: t('common:messageTypes.singular.ORDER'), value: DocumentType.order },
      {
        label: t('common:messageTypes.singular.ORDER_RESPONSE'),
        value: DocumentType.orderResponse,
      },
      {
        label: t('common:messageTypes.singular.DISPATCH_INSTRUCTION'),
        value: DocumentType.dispatchInstruction,
      },
      {
        label: t('common:messageTypes.singular.DISPATCH_INSTRUCTION_RESPONSE'),
        value: DocumentType.dispatchResponse,
      },
      {
        label: t('common:messageTypes.singular.WORK_ORDER'),
        value: DocumentType.workOrder,
      },
      {
        label: t('common:messageTypes.singular.SHIPPING_NOTICE'),
        value: DocumentType.shippingNotice,
      },
      { label: t('common:messageTypes.singular.INVOICE'), value: DocumentType.invoice },
      {
        label: t('common:messageTypes.singular.CREDIT_NOTE'),
        value: DocumentType.creditNote,
      },
      {
        label: t('common:messageTypes.singular.REMITTANCE_ADVICE'),
        value: DocumentType.remittanceAdvice,
      },
      {
        label: t('common:messageTypes.singular.PRODUCT_CATALOG'),
        value: DocumentType.productCatalog,
      },
      {
        label: t('common:messageTypes.singular.SALES_REPORT'),
        value: DocumentType.salesReport,
      },
      {
        label: t('common:messageTypes.singular.ACKNOWLEDGEMENT'),
        value: DocumentType.acknowledgement,
      },
      {
        label: t('common:messageTypes.singular.RECEIVAL_NOTICE'),
        value: DocumentType.receivalNotice,
      },
      { label: t('common:messageTypes.singular.UNKNOWN'), value: DocumentType.unknown },
    ].filter((option) => !exclude?.includes(option.value)),
  },
  eventDetails: {
    event: 'filter_changed',
    properties: {
      filter_type: 'documentType',
    },
  },
});

export const buildDocumentTypeFilterWithVirtual = (key: string, exclude?: Array<DocumentTypeWithVirtual>) => ({
  key,
  type: PropertyFilterType.dropdown,
  label: t('transactions:list.filter.messageTypes.label'),
  Icon: DocumentTextIcon,
  value: '',
  dropDownOptions: {
    multiple: true,
    subOptions: {
      defaultLabel: t('common:components.filters.direction.both'),
      values: [
        { value: 'INBOUND', label: t('common:components.filters.direction.incoming') },
        { value: 'OUTBOUND', label: t('common:components.filters.direction.outgoing') },
      ],
    },
    dropdownValues: [
      { label: t('common:messageTypes.singular.ORDER'), value: DocumentTypeWithVirtual.order },
      {
        label: t('common:messageTypes.singular.ORDER_CONFIRMATION'),
        value: DocumentTypeWithVirtual.orderConfirmation,
      },
      {
        label: t('common:messageTypes.singular.ORDER_REJECTION'),
        value: DocumentTypeWithVirtual.orderRejection,
      },
      {
        label: t('common:messageTypes.singular.PARTIAL_ORDER_CONFIRMATION'),
        value: DocumentTypeWithVirtual.partialOrderConfirmation,
      },
      {
        label: t('common:messageTypes.singular.DISPATCH_INSTRUCTION'),
        value: DocumentTypeWithVirtual.dispatchInstruction,
      },
      {
        label: t('common:messageTypes.singular.DISPATCH_INSTRUCTION_RESPONSE'),
        value: DocumentTypeWithVirtual.dispatchResponse,
      },
      {
        label: t('common:messageTypes.singular.WORK_ORDER'),
        value: DocumentTypeWithVirtual.workOrder,
      },
      {
        label: t('common:messageTypes.singular.SHIPPING_NOTICE'),
        value: DocumentTypeWithVirtual.shippingNotice,
      },
      { label: t('common:messageTypes.singular.INVOICE'), value: DocumentTypeWithVirtual.invoice },
      {
        label: t('common:messageTypes.singular.CREDIT_NOTE'),
        value: DocumentTypeWithVirtual.creditNote,
      },
      {
        label: t('common:messageTypes.singular.DEBIT_NOTE'),
        value: DocumentTypeWithVirtual.debitNote,
      },
      {
        label: t('common:messageTypes.singular.SERVICE_INVOICE'),
        value: DocumentTypeWithVirtual.serviceInvoice,
      },
      {
        label: t('common:messageTypes.singular.REMITTANCE_ADVICE'),
        value: DocumentTypeWithVirtual.remittanceAdvice,
      },
      {
        label: t('common:messageTypes.singular.PRODUCT_CATALOG'),
        value: DocumentTypeWithVirtual.productCatalog,
      },
      {
        label: t('common:messageTypes.singular.INVENTORY_REPORT'),
        value: DocumentTypeWithVirtual.inventoryReport,
      },
      {
        label: t('common:messageTypes.singular.STOCK_MOVEMENT'),
        value: DocumentTypeWithVirtual.stockMovement,
      },
      {
        label: t('common:messageTypes.singular.SALES_REPORT'),
        value: DocumentTypeWithVirtual.salesReport,
      },
      {
        label: t('common:messageTypes.singular.ACKNOWLEDGEMENT'),
        value: DocumentTypeWithVirtual.acknowledgement,
      },
      {
        label: t('common:messageTypes.singular.RECEIVAL_NOTICE'),
        value: DocumentTypeWithVirtual.receivalNotice,
      },
      { label: t('common:messageTypes.singular.UNKNOWN'), value: DocumentTypeWithVirtual.unknown },
    ].filter((option) => !exclude?.includes(option.value)),
  },
  eventDetails: {
    event: 'filter_changed',
    properties: {
      filter_type: 'documentType',
    },
  },
});
